/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import Select, { components } from 'react-select';
import Multiselect from 'multiselect-react-dropdown';
import utils from '../../../../lib/utils';

import './index.scss';
import moment from 'moment';

Modal.setAppElement('#root');

class InstallLayover extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentWillReceiveProps(nextProps) {

  }

  componentDidMount(){

  }

  render() {
    const { modelopen, closeServiceModal, schedules, deleteServiceType, selectedService, deleteSchedule, deleteData } = this.props;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeServiceModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title">Are you sure?</div>
              <button className="modal-close" onClick={closeServiceModal}>
                X
              </button>
              <div className="modal-description">
              You are about to delete a time entry. This cannot be undone.
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" disabled={schedules.deleteScheduleDefinition} onClick={()=>deleteSchedule(deleteData)}>{schedules.deleteScheduleDefinition? 'DELETING..':'DELETE'}</button>
                  <button className="btn btn--secondary btn--lg" onClick={closeServiceModal}>CANCEL</button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InstallLayover;
